import { type CreditCardDialogContext } from '@cart-services/hooks/credit-card-dialog-types'
import { DialogCreditCardConfirm } from '@cart-ui/DialogCreditCardConfirm/DialogCreditCardConfirm'
import { type CountryCode } from '@constants'
import { type CheckoutPayCreditCardModule } from '@payments'
import { useFpCampaignCreditCardDialogFlow } from './useFpCampaignCreditCardDialogFlow'

export interface CampaignCreditCardDialogProps {
  context: CreditCardDialogContext
  paymentModule: CheckoutPayCreditCardModule
  countryCode: CountryCode
  onClose: () => void
  onError: (error: unknown) => void
  isCreditCardValid: boolean
  /** 確定要整頁導頁前呼叫，供 caller 切換全頁 loading。 */
  onRedirecting: () => void
}

export const CampaignCreditCardDialog = ({
  context,
  paymentModule,
  countryCode,
  onClose,
  onError,
  isCreditCardValid,
  onRedirecting,
}: CampaignCreditCardDialogProps) => {
  const { mountCreditCardFields, submitAndExecute, cancelInFlight, revealCardValidationErrors } = useFpCampaignCreditCardDialogFlow({
    paymentModule,
    countryCode,
    onRedirecting,
  })
  // campaign 無會員登入，不支援記住卡片，故不傳 remember-me 相關 props
  return (
    <DialogCreditCardConfirm
      context={context}
      onClose={onClose}
      onError={onError}
      isCreditCardValid={isCreditCardValid}
      revealCardValidationErrors={revealCardValidationErrors}
      mountCreditCardFields={mountCreditCardFields}
      submitAndExecute={submitAndExecute}
      cancelInFlight={cancelInFlight}
    />
  )
}
